package net.sergeych.intecowork.api

enum class DocType(val text: String) {
    Text("текстовый документ"),
    Spreadsheet("электронная таблица"),
    Folder("папка"),
    ;

    override fun toString(): String = text
}